"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContrastTextColor = exports.getCSSVariable = exports.getTailwindBorderColorClass = exports.getTailwindBgColorClass = exports.getTailwindTextColorClass = exports.getColorName = exports.getTailwindColorClass = exports.fullColorDict = exports.colorDict = exports.colorsHex = exports.EColorPicker = void 0;
const HelperUtils_1 = require("./HelperUtils");
var EColorPicker;
(function (EColorPicker) {
    EColorPicker["PINK"] = "EC4899";
    EColorPicker["CRIMSON"] = "F43F5E";
    EColorPicker["AMBER"] = "F59E0B";
    EColorPicker["LIME"] = "84CC16";
    EColorPicker["TEAL"] = "14B8A6";
    EColorPicker["LIGHT_BLUE"] = "0EA5E9";
    EColorPicker["INDIGO"] = "6366F1";
    EColorPicker["VIOLET"] = "6D3AF8";
    EColorPicker["ORANGE"] = "F97316";
    EColorPicker["EMERALD"] = "10B981";
    EColorPicker["CYAN"] = "06B6D4";
    EColorPicker["FUCHSIA"] = "D946EF";
    EColorPicker["RED"] = "EF4444";
    EColorPicker["YELLOW"] = "EAB308";
    EColorPicker["GREEN"] = "22C55E";
    EColorPicker["BLUE"] = "3B82F6";
})(EColorPicker || (exports.EColorPicker = EColorPicker = {}));
exports.colorsHex = {
    '#5417CF': 'v',
    '#DB2777': 'p',
    '#E11D48': 'c',
    '#D97706': 'a',
    '#EA580C': 'o',
    '#65A30D': 'l',
    '#059669': 'e',
    '#0D9488': 't',
    '#0891B2': 'cy',
    '#0284C7': 'lb',
    '#4F46E5': 'i',
    '#C026D3': 'f',
    '#1D4DED': 'b'
};
exports.colorDict = {
    EC4899: 'p',
    F43F5E: 'c',
    F59E0B: 'a',
    '84CC16': 'l',
    '14B8A6': 't',
    '0EA5E9': 'lb',
    '6366F1': 'i',
    '6D3AF8': 'v',
    F97316: 'o',
    '10B981': 'e',
    '06B6D4': 'cy',
    D946EF: 'f',
    EF4444: 'r',
    EAB308: 'y',
    '22C55E': 'g',
    '3B82F6': 'b',
    '1D4DED': 'b'
};
exports.fullColorDict = {
    EC4899: 'Pink',
    F43F5E: 'Crimson',
    F59E0B: 'Amber',
    '84CC16': 'Lime',
    '14B8A6': 'Teal',
    '0EA5E9': 'Light Blue',
    '6366F1': 'Indigo',
    '6D3AF8': 'Violet',
    F97316: 'Orange',
    '10B981': 'Emerald',
    '06B6D4': 'Cyan',
    D946EF: 'Fuchsia',
    EF4444: 'Red',
    EAB308: 'Yellow',
    '22C55E': 'Green',
    '3B82F6': 'Blue'
};
const getTailwindColorClass = ({ hexCode, classPrefix, shade = 700 }) => {
    let alias = 'n';
    if (hexCode && exports.colorDict[hexCode]) {
        alias = exports.colorDict[hexCode];
    }
    return `${classPrefix}-${alias}-${shade}`;
};
exports.getTailwindColorClass = getTailwindColorClass;
const getColorName = ({ hexcode }) => {
    return exports.fullColorDict[hexcode]?.toLowerCase() || '';
};
exports.getColorName = getColorName;
const getTailwindTextColorClass = ({ hexCode, shade }) => {
    return (0, exports.getTailwindColorClass)({ hexCode, classPrefix: 'text', shade });
};
exports.getTailwindTextColorClass = getTailwindTextColorClass;
const getTailwindBgColorClass = ({ hexCode, shade = 100 }) => {
    return (0, exports.getTailwindColorClass)({ hexCode, classPrefix: 'bg', shade });
};
exports.getTailwindBgColorClass = getTailwindBgColorClass;
const getTailwindBorderColorClass = ({ hexCode, shade = 200 }) => {
    return (0, exports.getTailwindColorClass)({ hexCode, classPrefix: 'border', shade });
};
exports.getTailwindBorderColorClass = getTailwindBorderColorClass;
const getCSSVariable = ({ hexCode, shade = 700 }) => {
    const alias = hexCode ? exports.colorDict[hexCode] : 'n';
    return (0, HelperUtils_1.getCssVariableValue)(`--${alias}-${shade}`);
};
exports.getCSSVariable = getCSSVariable;
// Pick a readable text colour (white or near-black) for a chip painted with an
// arbitrary user-chosen background hex (e.g. a label). The chip background is a
// fixed colour that does NOT change between light/dark themes, so the text colour
// is fixed too — computed from the background's WCAG relative luminance rather
// than a theme token (a token would flip and collapse into the colour on one side).
const getContrastTextColor = (hexColor) => {
    const LIGHT = '#ffffff';
    const DARK = '#0f172a';
    if (!hexColor)
        return LIGHT;
    const hex = hexColor.replace('#', '').trim();
    if (hex.length < 6)
        return LIGHT;
    const channel = (start) => {
        const value = parseInt(hex.slice(start, start + 2), 16) / 255;
        if (Number.isNaN(value))
            return NaN;
        return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    };
    const luminance = 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4);
    if (Number.isNaN(luminance))
        return LIGHT;
    // The white/near-black crossover for maximum contrast sits near 0.2 relative
    // luminance: brighter backgrounds read better with dark text, darker with white.
    return luminance > 0.2 ? DARK : LIGHT;
};
exports.getContrastTextColor = getContrastTextColor;
